import { Stack, VStack, Tr } from '@chakra-ui/react'
import { animated } from 'react-spring'

export const AnimatedBox = animated(Stack)
export const AnimatedTr = animated(Tr)
export const AnimatedVStack = animated(VStack)
export const AnimatedStack = animated(Stack)
